// import $ from "jquery";
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'facture-rembourse',
    components: {
        VueHtml2pdf, EnteteBonEtFacture,
    },
    props: [],
    data() {
        return {
            assur_selected: '',     //  Selection d'une assurance
            options: { placeholder: "Choisir une option" },

            // Choix mois courant
            curr_month_selected: {},

            date: new Date(),
            monthsLatest: new Array(),

            filter_loading: false,
            filter_match: false,

            fields: [
                { key: 'index', label: 'N°' }, 'facture_date', { key: 'societe', label: 'Société' }, 
                { key: 'code_assur_principal', label: 'Matricule Assuré principal'}, { key: 'matricule', label: 'N° Dossier' }, 'patient', 
                { key: 'part_assureur', label: 'Part assureur' }
            ],
            filter: "",
            tableIsBusy: true,
            perPage: 5,
            print_per_page: -1,
            currentPage: 1,

            months: [
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            curr_month: {},          // Current month of the year
            liste_of_months: {},
            filter_date: '',

            filename: '',
            is_printing: false,
        }
    },

    watch: {
        assur_selected() {
            let data = {
                assurance_id: this.assur_selected.id,
                period: this.curr_month.id
            }
            this.filtreFacture(data)
        },

        curr_month() {
            let data = {
                assurance_id: this.assur_selected.id,
                period: this.curr_month.id
            }
            this.filtreFacture(data)
        },
    },

    computed: {
        assurances() {
            return this.$store.getters["assurances"];
        },

        facture_rembours() {
            return this.$store.getters["facture_rembours"];
        },

        rows() {
            return this.facture_rembours.length;
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
         monthOfYear() {
            let index;
            var m = []
            for (index = 0; index < this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },
    },

    mounted() {
        this.$store.dispatch("getAssurances")

        this.curr_month_selected = this.currentMonth

        this.curr_month = this.monthOfYear[this.date.getMonth()]
    },
    methods: {
        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        filtreFacture(data_filter) {
            let assurance_id = this.assur_selected.id

            if (assurance_id == undefined) {
                return;
            }

            var d = new Date()
            var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()
            this.filename = 'Demande remboursement_'+this.assur_selected.raison_sociale+'_'+this.curr_month['lib']+'_'+tmpstamp

            this.filter_loading = true

            this.$store.dispatch('getFactureRembourse', data_filter).then(() => {
                if (this.facture_rembours.length > 0) {
                    this.filter_match = true
                } else {
                    this.filter_match = false
                }
                this.filter_loading = false
            })
        },

        printBill() {
            this.is_printing = true

            setTimeout(() => {
                
                setTimeout(() => {
                    this.is_printing = false
                }, 500);
    
                this.$refs.html2Pdf.generatePdf()
            }, 1000);
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).set(
                {
                    margin: [0.5, 0, 1, 0], 
                    pageBreak: { mode: 'css', before:'#nextpage1'},
                }
            ).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(10)
                    pdf.text('Page ' + i + ' sur ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                } 
            }).save()
        },
        
    }
}


